import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1762391824591'
        class='icon'
        viewBox='0 0 1378 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='12684'
        width='200'
        height='200'
    >
        <path
            d='M66.663 942.891H1254.94c22.337 0 40.555 18.218 40.555 40.555S1277.277 1024 1254.94 1024H66.663c-22.337 0-40.554-18.218-40.554-40.554 0-22.337 18.217-40.555 40.554-40.555z m999.604-99.327H255.178c-73.03 0-131.802-58.772-131.802-131.802v-579.96C123.376 58.772 182.148 0 255.178 0h811.09c73.029 0 131.801 58.772 131.801 131.802v579.96c0 72.872-58.772 131.802-131.802 131.802zM255.178 81.11c-28.356 0-50.693 22.337-50.693 50.693v579.96c0 28.357 22.337 50.693 50.693 50.693h811.09c28.356 0 50.692-22.336 50.692-50.693v-579.96c0-28.356-22.336-50.693-50.693-50.693H255.178z'
            p-id='12685'
            fill='currentColor'
        ></path>
        <path
            d='M977.079 387.327h-76.99c-8.08 0-14.258 2.06-20.277 6.02l-34.535 26.297-34.376-30.416c-8.08-6.02-18.218-10.139-28.357-8.08-10.138 2.06-18.218 8.08-24.396 18.218l-34.534 69.07-26.297-186.614c-2.06-14.258-12.198-26.297-28.357-28.357-14.257-2.06-28.356 6.02-34.534 18.218l-62.892 137.822-46.574-46.574c-6.02-6.02-14.257-10.139-22.336-10.139s-16.159 4.119-22.337 10.139l-30.416 30.416h-89.188c-16.158 0-28.357 12.198-28.357 28.356s12.199 28.356 28.357 28.356h99.327c8.079 0 16.158-4.118 22.336-10.138l20.278-20.277 52.752 52.752c8.08 8.08 18.218 10.139 28.356 10.139 10.14-2.06 20.278-8.08 24.396-18.218l42.614-93.307 24.396 180.436c2.06 14.257 12.198 26.297 26.297 28.356h6.02c12.198 0 24.396-6.02 28.357-18.218l54.812-109.465 24.396 24.396c12.198 10.138 30.415 12.198 42.613 2.06l44.674-34.535h68.91c16.159 0 28.357-12.198 28.357-28.357 5.861-14.257-6.178-28.356-22.495-28.356z'
            p-id='12686'
            fill='currentColor'
        ></path>
    </svg>
)

export const OnSiteProcessingIcon = props => <Icon component={SVG} {...props} />
